var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"facebook",on:{"click":_vm.onFacebook}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }